/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalPrivateFileDto } from "../models/AjaxResponseOfListOfOperationalPrivateFileDto";
import type { AjaxResponseOfOperationalPrivateFileDto } from "../models/AjaxResponseOfOperationalPrivateFileDto";
import type { AjaxResponseOfPresignOperationalPrivateFileDownloadOutput } from "../models/AjaxResponseOfPresignOperationalPrivateFileDownloadOutput";
import type { AjaxResponseOfPresignOperationalPrivateFileUploadOutput } from "../models/AjaxResponseOfPresignOperationalPrivateFileUploadOutput";
import type { PresignOperationalPrivateFileUploadInput } from "../models/PresignOperationalPrivateFileUploadInput";
import type { RegisterOperationalPrivateFileInput } from "../models/RegisterOperationalPrivateFileInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalOrganizationFilesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPresignOperationalPrivateFileDownloadOutput Success
   * @throws ApiError
   */
  public presignDownload({
    fileId,
    ownerType,
  }: {
    fileId: number;
    ownerType?: string;
  }): CancelablePromise<AjaxResponseOfPresignOperationalPrivateFileDownloadOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/files/{fileId}/presign-download",
      path: {
        fileId: fileId,
      },
      query: {
        ownerType: ownerType,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfOperationalPrivateFileDto Success
   * @throws ApiError
   */
  public getAll({
    organizationId,
  }: {
    organizationId: number;
  }): CancelablePromise<AjaxResponseOfListOfOperationalPrivateFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/files",
      path: {
        organizationId: organizationId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalPrivateFileDto Success
   * @throws ApiError
   */
  public create({
    organizationId,
    requestBody,
  }: {
    organizationId: number;
    requestBody?: RegisterOperationalPrivateFileInput;
  }): CancelablePromise<AjaxResponseOfOperationalPrivateFileDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/files",
      path: {
        organizationId: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfPresignOperationalPrivateFileUploadOutput Success
   * @throws ApiError
   */
  public presignUpload({
    organizationId,
    requestBody,
  }: {
    organizationId: number;
    requestBody?: PresignOperationalPrivateFileUploadInput;
  }): CancelablePromise<AjaxResponseOfPresignOperationalPrivateFileUploadOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/files/presign-upload",
      path: {
        organizationId: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    organizationId,
    fileId,
  }: {
    organizationId: number;
    fileId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/files/{fileId}",
      path: {
        organizationId: organizationId,
        fileId: fileId,
      },
    });
  }
}
